// The page the user lands on after opening the app and without a session
export const TutorialPage = 'TutorialPage';

// // The main page the user will see as they use the app over a long period of time.
// // Change this if not using tabs
export const MainPage = 'DashboardPage';

export const LoginPage = 'LoginPage';

// // The initial root pages for our tabs (remove if not using tabs)
export const Tab1Root = 'CoinDetailsPage';
export const Tab2Root = 'CoinChartsPage';
export const Tab3Root = 'CoinMarketsPage';



// WEBPACK FOOTER //
// ./src/pages/pages.ts